<template>
  <ul
    v-if="!hasError"
    data-testid="interior-results"
    class="grid sm:grid-cols-2 gap-3"
  >
    <li
      v-if="isNewJob"
      class="flex justify-between sm:flex-col bg-white px-3 py-4"
    >
      <h4 class="sm:text-md flex items-center leading-tight">
        <a
          class="link underline"
          href="/supplementary/undercoat-pigmented-sealer"
          target="_blank"
          >Primer</a
        >
        <ButtonInfo
          class="ml-2"
          heading=""
          body="Our undercoat/pigmented sealer is the the perfect all-round primer – suited for most interior spaces and timbers"
        />
      </h4>
      <p class="sm:text-md font-semibold">
        {{ quantities.primer | formatVolume }}
      </p>
    </li>
    <li class="flex justify-between sm:flex-col bg-white px-3 py-4">
      <h4 class="sm:text-md flex items-center leading-tight">
        <a class="link underline" href="/paint/wall-paint" target="_blank"
          >Wall Paint</a
        >
        <ButtonInfo
          class="ml-2"
          heading=""
          body="A durable & washable interior wall paint"
        />
      </h4>
      <p class="sm:text-md font-semibold">
        {{ quantities.wallPaint | formatVolume }}
      </p>
    </li>
    <li class="flex justify-between sm:flex-col bg-white px-3 py-4">
      <h4 class="sm:text-md flex items-center leading-tight">
        <a class="link underline" href="/paint/ceiling-paint" target="_blank"
          >Ceiling Paint</a
        >
        <ButtonInfo
          class="ml-2"
          heading=""
          body="A high coverage matt finish perfect for ceilings"
        />
      </h4>
      <p class="sm:text-md font-semibold">
        {{ quantities.ceilingPaint | formatVolume }}
      </p>
    </li>
    <li class="flex justify-between sm:flex-col bg-white px-3 py-4">
      <h4 class="sm:text-md flex items-center leading-tight">
        <a class="link underline" href="/paint/enamel-paint" target="_blank"
          >Enamel Paint</a
        >
        <ButtonInfo
          class="ml-2"
          heading=""
          body="Hard wearing & washable finish for doors, windows, cabinetry and bathrooms"
        />
      </h4>
      <p class="sm:text-md font-semibold">
        {{ quantities.enamelPaint | formatVolume }}
      </p>
    </li>
  </ul>
</template>

<script>
import ButtonInfo from "../../ui/ButtonInfo.vue";

export default {
  name: "InteriorResultsPanel",

  components: { ButtonInfo },

  props: {
    isNewJob: {
      type: Boolean,
      required: true,
    },
    quantities: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasError() {
      return Array.from(Object.values(this.quantities)).some(
        (value) => value === undefined
      );
    },
  },
};
</script>
